export default {
    allRightsReserved:'All rights reserved',
}